import { Controller } from "@hotwired/stimulus"

// Mobile : n'affiche que les premières cartes, le bouton « Voir la suite » montre le reste.
export default class extends Controller {
  static targets = ["list", "button"]

  show() {
    this.element.classList.add("is-revealed")
    if (this.hasButtonTarget) this.buttonTarget.hidden = true
  }
}
